import { Translations } from '../types';

export const en: Translations = {
  common: {
    loading: 'Loading...',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    all: 'All',
    viewAll: 'View All',
    copy: 'Copy',
    copied: 'Copied!',
    success: 'Success',
    error: 'Error',
    close: 'Close',
  },
  nav: {
    home: 'Home',
    linkExchange: 'Link Exchange',
    rebate: 'Rebate',
    exchanges: 'Exchanges',
    withdraw: 'Withdraw',
    history: 'History',
    checkIn: 'Check In',
    profile: 'Profile',
    overview: 'Overview',
    rewardHub: 'Reward Hub',
    settings: 'Settings',
  },
  dashboard: {
    title: 'Welcome, {name}!',
    subtitle: 'Your account overview',
    balance: 'Balance',
    totalEarned: 'Total Earned',
    pendingRebate: 'Pending Rebate',
    availablePoints: 'Available XP',
    recentRebates: 'Recent Rebates',
    recentWithdrawals: 'Recent Withdrawals',
  },
  linkExchange: {
    title: 'Link Exchange Account',
    subtitle: 'Connect your exchange UID to enable automatic fee tracking',
    exchange: 'Exchange',
    uid: 'UID',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    linkAccount: 'Link Account',
    linkedAccounts: 'Linked Accounts',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    delete: 'Delete Account',
    selectExchange: 'Select Exchange',
    enterUID: 'Enter UID',
    enterApiKey: 'Enter API Key',
    enterApiSecret: 'Enter API Secret',
    accountLinked: 'Account linked successfully',
    accountDeleted: 'Account deleted successfully',
    binance: 'Binance',
    bybit: 'Bybit',
    okx: 'OKX',
    gate: 'Gate.io',
  },
  rebate: {
    title: 'Trading Fee Rebate',
    subtitle: 'Automatic rebate payment history',
    totalRebate: 'Total Rebate',
    pendingRebate: 'Pending Rebate',
    balance: 'Balance',
    withdraw: 'Withdraw',
    rebateHistory: 'Rebate History',
    date: 'Date',
    amount: 'Amount',
    status: 'Status',
    completed: 'Completed',
    pending: 'Pending',
    failed: 'Failed',
    description: 'Description',
    autoRebate: 'Automatic Rebate',
    autoRebateDesc: 'The system will automatically rebate trading fees to your account. Processing time: 1-3 business days.',
  },
  withdraw: {
    title: 'Withdraw',
    subtitle: 'Withdraw funds to your wallet',
    availableBalance: 'Available Balance',
    withdrawAmount: 'Withdraw Amount',
    walletAddress: 'Wallet Address (or UID)',
    network: 'Network',
    selectNetwork: 'Select Network',
    enterAmount: 'Enter amount',
    enterWalletAddress: 'Enter wallet address (or UID)',
    withdraw: 'Withdraw',
    minWithdraw: 'Minimum withdrawal: {amount}',
    fee: 'Fee',
    receiveAmount: 'You will receive',
    withdrawHistory: 'Withdrawal History',
    processing: 'Processing',
    completed: 'Completed',
    failed: 'Failed',
    trc20: 'TRC20',
    erc20: 'ERC20',
    bep20: 'BEP20',
    pleaseEnterAmount: 'Please enter a valid amount',
    pleaseEnterWallet: 'Please enter wallet address',
    pleaseSelectNetwork: 'Please select a network',
    invalidAmount: 'Invalid amount',
    amountTooLow: 'Amount below minimum withdrawal',
    insufficientBalance: 'Insufficient balance',
    confirmWithdrawal: 'Confirm Withdrawal',
    withdrawalSubmitted: 'Withdrawal request submitted successfully! Check History for claim status.',
    withdrawalFailed: 'Withdrawal failed',
    note: 'Note',
    withdrawalNote: 'Gas fees will be deducted from the withdrawal amount',
  },
  history: {
    title: 'Transaction History',
    subtitle: 'View all your transactions and withdrawals',
    transactions: 'Transactions',
    withdrawals: 'Withdrawals',
    rebates: 'Rebates',
    date: 'Date',
    type: 'Type',
    amount: 'Amount',
    status: 'Status',
    noTransactions: 'No transactions found',
    noWithdrawals: 'No withdrawals found',
    noRebates: 'No rebates found',
    claimNow: 'Claim Now',
    claiming: 'Claiming...',
    readyToClaim: 'Ready to claim from smart contract',
    claimedSuccessfully: 'Claimed successfully!',
    failedToClaim: 'Failed to claim',
    noMoreItems: 'No more items',
    payGas: 'Pay Gas',
    claimed: 'Claimed',
    noHistoryFound: 'No history found',
    statusCompleted: 'Completed',
    statusPending: 'Pending',
    statusFailed: 'Failed',
    statusProcessing: 'Processing',
    statusRejected: 'Rejected',
  },
  checkIn: {
    title: 'Daily Check In',
    subtitle: 'Check in daily to earn XP',
    checkIn: 'Check In',
    checkedIn: 'Checked In',
    todayPoints: "Today's XP",
    totalPoints: 'Total XP',
    points: 'XP',
    redeem: 'Redeem',
    rewards: 'Rewards',
    vouchers: 'Vouchers',
    linkReward: 'Link Reward',
    linkExchange: 'Link Exchange Account',
    linkRewardDesc: 'Link your exchange account to receive bonus XP',
    rewardHistory: 'Reward History',
    availableRewards: 'Available Rewards',
    voucher: 'Voucher',
    gift: 'Gift',
    pointsRequired: 'XP Required',
    redeemNow: 'Redeem Now',
    redeemed: 'Redeemed',
    noRewards: 'No rewards available',
    shop: 'Shop',
    myCodes: 'My Codes',
    backButton: '← Back',
    noPointsHistory: 'No XP history',
    myRedeemedCodes: 'My Redeemed Codes',
    yourCode: 'Your Code:',
    codeCopied: 'Code copied!',
    noRedeemedYet: 'No redeemed rewards yet',
    dailyCheckIn: 'Daily Check-in',
    tasks: 'Tasks',
    checkedInSuccessfully: 'Checked in successfully!',
    checkInFailed: 'Check-in failed',
    claimedTask: 'Task claimed successfully!',
    failedToClaimTask: 'Failed to claim task',
    insufficientPoints: 'Insufficient XP',
    redeemFailed: 'Redeem failed',
    special: 'Special',
    social: 'Social',
    trading: 'Trading',
    watchAd: 'Watch Ad',
    available: 'available',
    completed: 'completed',
    comingSoon: 'Coming Soon',
    times: 'times',
    weeklyLeaderboard: 'Weekly XP Leaderboard',
    leaderboardSubtitle: 'Top performers this week',
    yourRank: 'Your Rank',
    yourXP: 'Your XP',
    you: 'You',
    noLeaderboardData: 'No leaderboard data yet',
    prize: 'Prize',
  },
  profile: {
    title: 'Profile',
    accountInfo: 'Account Information',
    telegramId: 'Telegram ID',
    joinDate: 'Join Date',
    language: 'Language',
    english: 'English',
    vietnamese: 'Vietnamese',
    spanish: 'Spanish',
    portuguese: 'Portuguese',
    chinese: 'Chinese',
    indonesian: 'Indonesian',
    emailSettings: 'Email Settings',
    notSet: 'Not set',
    logout: 'Logout',
    logoutConfirm: 'Are you sure you want to logout?',
  },
  login: {
    title: 'CashBackHub',
    subtitle: 'Trading Fee Rebate System',
    description: 'Telegram Mini App',
    hint: 'Please open the app from Telegram',
    login: 'Login',
  },
  exchanges: {
    title: 'Exchanges',
    subtitle: 'Choose your referral type',
    chooseReferralType: 'Choose your referral type',
    exchangeReferral: 'Exchange Referral',
    linkYourUid: 'Link your UID',
    copyTrade: 'Copy Trade',
    followTrades: 'Follow our trades',
    filterByExchange: 'Filter by exchange:',
    allExchanges: 'All Exchanges',
    accounts: 'account(s)',
    account: 'Account',
    connected: 'Connected',
    uidCopied: 'UID copied!',
    totalRebate: 'Total Rebate',
    transactionVolume: 'Transaction Volume',
    waitingForSync: 'Waiting for sync',
    cashbackHubRebate: 'CashbackHub Rebate',
    viewReason: 'View Reason',
    reconnect: 'Reconnect',
    noAccounts: 'No exchange accounts yet',
    rejectionReason: 'Rejection Reason',
    exchangeConnected: 'Exchange connected successfully!',
    notConfigured: 'Not configured yet',
    noExchangesAvailable: 'No Exchanges Available',
    pleaseContactSupport: 'Please contact our support team to set up exchanges for your account.',
    allAccounts: 'All',
    activeAccounts: 'Active',
    pendingAccounts: 'Pending',
    rejectedAccounts: 'Rejected',
    totalProfit: 'Total Profit',
    noCopyTradeAccounts: 'No copy trade accounts yet',
    rejectionReasonText: 'This UID has not been registered under our referral system. Please contact our support team @backcashhub for detailed instructions on how to complete the registration process!',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Customize your experience and manage your account details',
    telegramNotifications: 'Telegram Notifications',
    profile: 'Profile',
    telegramNotificationsDesc: 'Get instant updates via Telegram',
    uid: 'UID',
    connected: 'Connected',
    connect: 'Connect',
    emailVerification: 'Email Verification',
    emailAddress: 'Email Address',
    sendVerificationCode: 'Send Verification Code',
    sending: 'Sending...',
    verificationCode: 'Verification Code',
    enterCode: 'Enter 6-digit code from your email',
    changeEmail: 'Change Email',
    resendCode: 'Resend Code',
    verifying: 'Verifying...',
    verifyEmail: 'Verify Email',
    codeExpired: 'Verification code has expired. Please request a new one.',
    invalidCode: 'Invalid verification code. Please try again.',
    verificationSent: 'Verification code sent successfully! Check your email.',
    emailVerified: 'Email verified successfully!',
    failedToSend: 'Failed to send verification code. Please try again.',
    failedToVerify: 'Failed to verify email. Please try again.',
    enterEmailPlaceholder: 'your.email@example.com',
    enterCodeDesc: 'Enter 6-digit code from your email',
  },
  copyTrade: {
    title: 'Copy Trade',
    notConfigured: 'Not configured yet',
    noExchangesAvailable: 'No Exchanges Available',
    pleaseContactSupport: 'Please contact our support team to set up exchanges for your account.',
    linkCopyTradeAccount: 'Link Copy Trade Account',
    selectExchange: 'Select Exchange',
    step1: 'Step 1: Click button below to copy trade',
    openCopyTradeLink: 'Open Copy Trade Link',
    clickToCopyTrade: 'Click to open our copy trade link and follow the instructions',
    step2: 'Step 2: Enter Your UID',
    enterYourUid: 'Enter Your UID',
    enterUidPlaceholder: 'Enter your UID on the exchange',
    submit: 'Submit',
    submitting: 'Submitting...',
    pleaseEnterUid: 'Please enter your UID',
    pleaseSelectExchange: 'Please select an exchange',
    pleaseSelectBot: 'Please select a bot',
    submittedSuccessfully: 'Copy trade account submitted successfully! Wait for approval.',
    accountRejectedPleaseResubmit: 'Your account was rejected. Please resubmit with correct information.',
    disabled: 'Disabled',
    accountDisabledMessage: 'This account has been disabled. Please contact support for more information.',
    submitFailed: 'Failed to submit copy trade account',
  },
  rules: {
    title: 'Rebate Rules',
    description: 'Profit rebate percentage based on profit milestones:',
    profitRange: 'Profit Range',
    rebatePercentage: 'Rebate',
    range1: '$100 - $200',
    range2: '$201 - $300',
    range3: '$301 - $400',
    range4: '$500+',
    note: 'Rebate is calculated based on incremental profit after exchange rebate deduction.',
    noRules: 'No rebate rules available',
  },
};

